{
  "abi": [
    {
      "type": "constructor",
      "inputs": [
        {
          "name": "_entryPoint",
          "type": "address",
          "internalType": "contract IEntryPoint"
        },
        {
          "name": "_registry",
          "type": "address",
          "internalType": "contract IRegistry"
        },
        {
          "name": "_ethUsdPriceFeed",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "APNTS_TOKEN",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "APNTS_TOKEN_TIMELOCK",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "BLS_AGGREGATOR",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "EMERGENCY_TIMELOCK",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "ETH_USD_PRICE_FEED",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract AggregatorV3Interface"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "REGISTRY",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IRegistry"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "UPGRADE_INTERFACE_VERSION",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "aPNTsPriceUSD",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "addStake",
      "inputs": [
        {
          "name": "unstakeDelaySec",
          "type": "uint32",
          "internalType": "uint32"
        }
      ],
      "outputs": [],
      "stateMutability": "payable"
    },
    {
      "type": "function",
      "name": "agentIdentityRegistry",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "agentReputationRegistry",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "applyBLSAggregator",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "cachedPrice",
      "inputs": [],
      "outputs": [
        {
          "name": "price",
          "type": "int256",
          "internalType": "int256"
        },
        {
          "name": "updatedAt",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "roundId",
          "type": "uint80",
          "internalType": "uint80"
        },
        {
          "name": "decimals",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "cancelAPNTsTokenChange",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "cancelEmergencyPrice",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "cancelSlash",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "clearPendingDebt",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "configureOperator",
      "inputs": [
        {
          "name": "xPNTsToken",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_opTreasury",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "deposit",
      "inputs": [
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "deposit",
      "inputs": [],
      "outputs": [],
      "stateMutability": "payable"
    },
    {
      "type": "function",
      "name": "depositFor",
      "inputs": [
        {
          "name": "targetOperator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "dryRunValidation",
      "inputs": [
        {
          "name": "userOp",
          "type": "tuple",
          "internalType": "struct PackedUserOperation",
          "components": [
            {
              "name": "sender",
              "type": "address",
              "internalType": "address"
            },
            {
              "name": "nonce",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "initCode",
              "type": "bytes",
              "internalType": "bytes"
            },
            {
              "name": "callData",
              "type": "bytes",
              "internalType": "bytes"
            },
            {
              "name": "accountGasLimits",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "preVerificationGas",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "gasFees",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "paymasterAndData",
              "type": "bytes",
              "internalType": "bytes"
            },
            {
              "name": "signature",
              "type": "bytes",
              "internalType": "bytes"
            }
          ]
        },
        {
          "name": "maxCost",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "ok",
          "type": "bool",
          "internalType": "bool"
        },
        {
          "name": "reasonCode",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "emergencyActivatedAt",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "emergencyPendingPrice",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "int256",
          "internalType": "int256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "emergencyQueuedAt",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "emergencySetPrice",
      "inputs": [
        {
          "name": "newPrice",
          "type": "int256",
          "internalType": "int256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "entryPoint",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "contract IEntryPoint"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "executeAPNTsTokenChange",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "executeEmergencyPrice",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "executeSlashWithBLS",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "internalType": "enum ISuperPaymaster.SlashLevel"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "getAvailableCredit",
      "inputs": [
        {
          "name": "user",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getDeposit",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getLatestSlash",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "tuple",
          "internalType": "struct ISuperPaymaster.SlashRecord",
          "components": [
            {
              "name": "timestamp",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "amount",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "reputationLoss",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "reason",
              "type": "string",
              "internalType": "string"
            },
            {
              "name": "level",
              "type": "uint8",
              "internalType": "enum ISuperPaymaster.SlashLevel"
            }
          ]
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getSlashCount",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "getSlashHistory",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "tuple[]",
          "internalType": "struct ISuperPaymaster.SlashRecord[]",
          "components": [
            {
              "name": "timestamp",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "amount",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "reputationLoss",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "reason",
              "type": "string",
              "internalType": "string"
            },
            {
              "name": "level",
              "type": "uint8",
              "internalType": "enum ISuperPaymaster.SlashLevel"
            }
          ]
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "initBLSAggregator",
      "inputs": [
        {
          "name": "_bls",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "initialize",
      "inputs": [
        {
          "name": "_owner",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_apntsToken",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_protocolTreasury",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_priceStalenessThreshold",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "isChainlinkStale",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "isEligibleForSponsorship",
      "inputs": [
        {
          "name": "user",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "isRegisteredAgent",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "isSlashPending",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "onTransferReceived",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "from",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "value",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bytes4",
          "internalType": "bytes4"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "operators",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "aPNTsBalance",
          "type": "uint128",
          "internalType": "uint128"
        },
        {
          "name": "isConfigured",
          "type": "bool",
          "internalType": "bool"
        },
        {
          "name": "isPaused",
          "type": "bool",
          "internalType": "bool"
        },
        {
          "name": "xPNTsToken",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "reputation",
          "type": "uint32",
          "internalType": "uint32"
        },
        {
          "name": "minTxInterval",
          "type": "uint48",
          "internalType": "uint48"
        },
        {
          "name": "treasury",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "totalSpent",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "totalTxSponsored",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "owner",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "pendingAPNTsToken",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "pendingAPNTsTokenEta",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "pendingBLSAgg",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "pendingBLSAggEta",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint48",
          "internalType": "uint48"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "pendingDebts",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "postOp",
      "inputs": [
        {
          "name": "mode",
          "type": "uint8",
          "internalType": "enum IPaymaster.PostOpMode"
        },
        {
          "name": "context",
          "type": "bytes",
          "internalType": "bytes"
        },
        {
          "name": "actualGasCost",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "actualUserOpFeePerGas",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "priceMode",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "priceStalenessThreshold",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "priceValidUntil",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint48",
          "internalType": "uint48"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "primeBlsSlashCooldown",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "protocolFeeBPS",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "protocolRevenue",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "proxiableUUID",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "queueBLSAggregator",
      "inputs": [
        {
          "name": "_bls",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "queueSlash",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "renounceOwnership",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "retryPendingDebt",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "sbtHolders",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "setAPNTSPrice",
      "inputs": [
        {
          "name": "newPrice",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setAPNTsToken",
      "inputs": [
        {
          "name": "newAPNTsToken",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setAgentRegistries",
      "inputs": [
        {
          "name": "_identity",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "_reputation",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setOperatorLimits",
      "inputs": [
        {
          "name": "_minTxInterval",
          "type": "uint48",
          "internalType": "uint48"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setOperatorPaused",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "paused",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setProtocolFee",
      "inputs": [
        {
          "name": "newFeeBPS",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setTreasury",
      "inputs": [
        {
          "name": "_treasury",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "setXPNTsFactory",
      "inputs": [
        {
          "name": "_factory",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "slashHistory",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "timestamp",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "reputationLoss",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "reason",
          "type": "string",
          "internalType": "string"
        },
        {
          "name": "level",
          "type": "uint8",
          "internalType": "enum ISuperPaymaster.SlashLevel"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "slashOperator",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "internalType": "enum ISuperPaymaster.SlashLevel"
        },
        {
          "name": "penaltyAmount",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "reason",
          "type": "string",
          "internalType": "string"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "totalTrackedBalance",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "transferOwnership",
      "inputs": [
        {
          "name": "newOwner",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "treasury",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "unlockStake",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updateBlockedStatus",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "users",
          "type": "address[]",
          "internalType": "address[]"
        },
        {
          "name": "statuses",
          "type": "bool[]",
          "internalType": "bool[]"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updatePrice",
      "inputs": [],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updatePriceDVT",
      "inputs": [
        {
          "name": "price",
          "type": "int256",
          "internalType": "int256"
        },
        {
          "name": "updatedAt",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "proof",
          "type": "bytes",
          "internalType": "bytes"
        },
        {
          "name": "chainlinkRecovered",
          "type": "uint8",
          "internalType": "uint8"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updateReputation",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "newScore",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "updateSBTStatus",
      "inputs": [
        {
          "name": "user",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "status",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "upgradeToAndCall",
      "inputs": [
        {
          "name": "newImplementation",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "data",
          "type": "bytes",
          "internalType": "bytes"
        }
      ],
      "outputs": [],
      "stateMutability": "payable"
    },
    {
      "type": "function",
      "name": "userOpState",
      "inputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "outputs": [
        {
          "name": "lastTimestamp",
          "type": "uint48",
          "internalType": "uint48"
        },
        {
          "name": "isBlocked",
          "type": "bool",
          "internalType": "bool"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "function",
      "name": "validatePaymasterUserOp",
      "inputs": [
        {
          "name": "userOp",
          "type": "tuple",
          "internalType": "struct PackedUserOperation",
          "components": [
            {
              "name": "sender",
              "type": "address",
              "internalType": "address"
            },
            {
              "name": "nonce",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "initCode",
              "type": "bytes",
              "internalType": "bytes"
            },
            {
              "name": "callData",
              "type": "bytes",
              "internalType": "bytes"
            },
            {
              "name": "accountGasLimits",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "preVerificationGas",
              "type": "uint256",
              "internalType": "uint256"
            },
            {
              "name": "gasFees",
              "type": "bytes32",
              "internalType": "bytes32"
            },
            {
              "name": "paymasterAndData",
              "type": "bytes",
              "internalType": "bytes"
            },
            {
              "name": "signature",
              "type": "bytes",
              "internalType": "bytes"
            }
          ]
        },
        {
          "name": "userOpHash",
          "type": "bytes32",
          "internalType": "bytes32"
        },
        {
          "name": "maxCost",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [
        {
          "name": "context",
          "type": "bytes",
          "internalType": "bytes"
        },
        {
          "name": "validationData",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "version",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "string",
          "internalType": "string"
        }
      ],
      "stateMutability": "pure"
    },
    {
      "type": "function",
      "name": "withdraw",
      "inputs": [
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "withdrawProtocolRevenue",
      "inputs": [
        {
          "name": "to",
          "type": "address",
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "withdrawStake",
      "inputs": [
        {
          "name": "to",
          "type": "address",
          "internalType": "address payable"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "withdrawTo",
      "inputs": [
        {
          "name": "to",
          "type": "address",
          "internalType": "address payable"
        },
        {
          "name": "amount",
          "type": "uint256",
          "internalType": "uint256"
        }
      ],
      "outputs": [],
      "stateMutability": "nonpayable"
    },
    {
      "type": "function",
      "name": "xpntsFactory",
      "inputs": [],
      "outputs": [
        {
          "name": "",
          "type": "address",
          "internalType": "address"
        }
      ],
      "stateMutability": "view"
    },
    {
      "type": "event",
      "name": "APNTsPriceUpdated",
      "inputs": [
        {
          "name": "oldPrice",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "newPrice",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "APNTsTokenChangeCancelled",
      "inputs": [
        {
          "name": "pendingToken",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "APNTsTokenChangeExecuted",
      "inputs": [
        {
          "name": "oldToken",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newToken",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "executedAt",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "APNTsTokenChangeQueued",
      "inputs": [
        {
          "name": "pendingToken",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "eta",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "APNTsTokenUpdated",
      "inputs": [
        {
          "name": "oldToken",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newToken",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "AgentRegistriesUpdated",
      "inputs": [
        {
          "name": "identityRegistry",
          "type": "address",
          "indexed": false,
          "internalType": "address"
        },
        {
          "name": "reputationRegistry",
          "type": "address",
          "indexed": false,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "BLSAggregatorQueued",
      "inputs": [
        {
          "name": "pending",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "eta",
          "type": "uint48",
          "indexed": false,
          "internalType": "uint48"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "BLSAggregatorUpdated",
      "inputs": [
        {
          "name": "oldAggregator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newAggregator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "BlsSlashCooldownPrimed",
      "inputs": [
        {
          "name": "floorUntil",
          "type": "uint48",
          "indexed": false,
          "internalType": "uint48"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "DebtRecordFailed",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "EmergencyPriceCancelled",
      "inputs": [
        {
          "name": "cancelledPrice",
          "type": "int256",
          "indexed": false,
          "internalType": "int256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "EmergencyPriceExecuted",
      "inputs": [
        {
          "name": "newPrice",
          "type": "int256",
          "indexed": false,
          "internalType": "int256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "EmergencyPriceQueued",
      "inputs": [
        {
          "name": "newPrice",
          "type": "int256",
          "indexed": false,
          "internalType": "int256"
        },
        {
          "name": "eta",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "Initialized",
      "inputs": [
        {
          "name": "version",
          "type": "uint64",
          "indexed": false,
          "internalType": "uint64"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorConfigured",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "xPNTsToken",
          "type": "address",
          "indexed": false,
          "internalType": "address"
        },
        {
          "name": "treasury",
          "type": "address",
          "indexed": false,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorDeposited",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorMinTxIntervalUpdated",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "minTxInterval",
          "type": "uint48",
          "indexed": false,
          "internalType": "uint48"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorPaused",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorSlashed",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "level",
          "type": "uint8",
          "indexed": false,
          "internalType": "enum ISuperPaymaster.SlashLevel"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorUnpaused",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OperatorWithdrawn",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OracleFallbackTriggered",
      "inputs": [
        {
          "name": "timestamp",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "OwnershipTransferred",
      "inputs": [
        {
          "name": "previousOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newOwner",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PendingDebtCleared",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PendingDebtRetried",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PriceModeChanged",
      "inputs": [
        {
          "name": "oldMode",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        },
        {
          "name": "newMode",
          "type": "uint8",
          "indexed": false,
          "internalType": "uint8"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "PriceUpdated",
      "inputs": [
        {
          "name": "price",
          "type": "int256",
          "indexed": true,
          "internalType": "int256"
        },
        {
          "name": "timestamp",
          "type": "uint256",
          "indexed": true,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProtocolFeeUpdated",
      "inputs": [
        {
          "name": "oldFee",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "newFee",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProtocolRevenueUnderflow",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "requestedRefund",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "availableRevenue",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ProtocolRevenueWithdrawn",
      "inputs": [
        {
          "name": "to",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "amount",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ReputationUpdated",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newScore",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashCancelled",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashExecutedWithProof",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "level",
          "type": "uint8",
          "indexed": false,
          "internalType": "enum ISuperPaymaster.SlashLevel"
        },
        {
          "name": "penalty",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "proofHash",
          "type": "bytes32",
          "indexed": false,
          "internalType": "bytes32"
        },
        {
          "name": "timestamp",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "SlashQueued",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "TransactionSponsored",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "aPNTsCost",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        },
        {
          "name": "debtAPNTs",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "TreasuryUpdated",
      "inputs": [
        {
          "name": "oldTreasury",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newTreasury",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "Upgraded",
      "inputs": [
        {
          "name": "implementation",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "UserBlockedStatusUpdated",
      "inputs": [
        {
          "name": "operator",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "user",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "isBlocked",
          "type": "bool",
          "indexed": false,
          "internalType": "bool"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "UserReputationAccrued",
      "inputs": [
        {
          "name": "user",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "aPNTsValue",
          "type": "uint256",
          "indexed": false,
          "internalType": "uint256"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "ValidationFailed",
      "inputs": [
        {
          "name": "userOpHash",
          "type": "bytes32",
          "indexed": true,
          "internalType": "bytes32"
        },
        {
          "name": "reasonCode",
          "type": "bytes32",
          "indexed": false,
          "internalType": "bytes32"
        }
      ],
      "anonymous": false
    },
    {
      "type": "event",
      "name": "XPNTsFactoryUpdated",
      "inputs": [
        {
          "name": "oldFactory",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        },
        {
          "name": "newFactory",
          "type": "address",
          "indexed": true,
          "internalType": "address"
        }
      ],
      "anonymous": false
    },
    {
      "type": "error",
      "name": "AddressEmptyCode",
      "inputs": [
        {
          "name": "target",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "AddressInsufficientBalance",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "AmountExceedsUint128",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ChainlinkNotStale",
      "inputs": []
    },
    {
      "type": "error",
      "name": "DepositNotVerified",
      "inputs": []
    },
    {
      "type": "error",
      "name": "ERC1967InvalidImplementation",
      "inputs": [
        {
          "name": "implementation",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ERC1967NonPayable",
      "inputs": []
    },
    {
      "type": "error",
      "name": "EmergencyExpired",
      "inputs": []
    },
    {
      "type": "error",
      "name": "EmergencyPriceOutOfRange",
      "inputs": []
    },
    {
      "type": "error",
      "name": "EmergencyTimelockNotElapsed",
      "inputs": []
    },
    {
      "type": "error",
      "name": "FailedInnerCall",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InsufficientBalance",
      "inputs": [
        {
          "name": "available",
          "type": "uint256",
          "internalType": "uint256"
        },
        {
          "name": "required",
          "type": "uint256",
          "internalType": "uint256"
        }
      ]
    },
    {
      "type": "error",
      "name": "InsufficientRevenue",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidAddress",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidConfiguration",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidInitialization",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidOwner",
      "inputs": []
    },
    {
      "type": "error",
      "name": "InvalidXPNTsToken",
      "inputs": []
    },
    {
      "type": "error",
      "name": "MathOverflowedMulDiv",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NoEmergencyPending",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NoPendingDebt",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NoSlashHistory",
      "inputs": []
    },
    {
      "type": "error",
      "name": "NotInitializing",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OracleError",
      "inputs": []
    },
    {
      "type": "error",
      "name": "OwnableInvalidOwner",
      "inputs": [
        {
          "name": "owner",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "OwnableUnauthorizedAccount",
      "inputs": [
        {
          "name": "account",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ReentrancyGuardReentrantCall",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SafeERC20FailedOperation",
      "inputs": [
        {
          "name": "token",
          "type": "address",
          "internalType": "address"
        }
      ]
    },
    {
      "type": "error",
      "name": "ScoreExceedsUint32",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SlashCooldown",
      "inputs": []
    },
    {
      "type": "error",
      "name": "SlashPending",
      "inputs": []
    },
    {
      "type": "error",
      "name": "UUPSUnauthorizedCallContext",
      "inputs": []
    },
    {
      "type": "error",
      "name": "UUPSUnsupportedProxiableUUID",
      "inputs": [
        {
          "name": "slot",
          "type": "bytes32",
          "internalType": "bytes32"
        }
      ]
    },
    {
      "type": "error",
      "name": "Unauthorized",
      "inputs": []
    }
  ],
  "bytecode": "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"
}
